import layout from '@/pages/Settings/AiAgents/components/agentLayout.module.css';
import { CustomizationComponent } from '@/pages/Logiblocks/types';
import styles from '../NodeCustomization.module.css';
import { FieldErrorLabel, FieldLabel, WaitDurationField } from '../shared';
import { WaitForReplyFields } from './WaitForReplyNodeInfo';

/**
 * Customization UI for WAIT_FOR_REPLY nodes: how long to wait for a reply to an earlier
 * "Don't wait" AI email (or for an earlier AI call to have been answered).
 */
export const WaitForReplyCustomization: CustomizationComponent = ({
  nodeData,
  onChange,
  isReadOnly = false,
  validationErrors,
}) => {
  const waitSeconds = nodeData.wait_for_reply?.wait_seconds ?? 0;
  const waitError = validationErrors?.find(
    (e) => e.field === WaitForReplyFields.WAIT
  );

  const handleChange = (seconds: number) => {
    onChange({ wait_for_reply: { wait_seconds: seconds } });
  };

  return (
    <div className={styles.customizationSection}>
      <FieldLabel required className={styles.sectionLabel}>
        {WaitForReplyFields.WAIT}
      </FieldLabel>
      <WaitDurationField
        seconds={waitSeconds}
        onChange={handleChange}
        disabled={isReadOnly}
        amountLabel={WaitForReplyFields.WAIT}
      />
      <FieldErrorLabel error={waitError} />
      <p className={layout.footerHint}>
        Continues as soon as an earlier &quot;Don&apos;t wait&quot; AI email
        gets a reply or the last AI call was answered. Otherwise continues with
        Replied false when the time is up.
      </p>
    </div>
  );
};
